import OwLabel from "../../../shared/OwLabel/OwLabel";
import { useSettingsPage } from "./SettingsPageContext";

type Props = {
    /**
     * Translation key of the reason prefix: "requires" ("Requires"), "not_used_while_on"
     * ("Not used while ... is on"), "turned_off_by" ("Turned off by"), "required_by" ("Required by"),
     * "with" ("With"). The linked setting's name follows it.
     */
    reasonKey: "requires" | "not_used_while_on" | "turned_off_by" | "required_by" | "with" | "not_available_with_on";
    /** Translation key of the setting this one depends on. */
    targetTitleKey: string;
    /** DOM id to jump to: a row id ("row-<name>"), a card id or a section id. */
    targetId: string;
    /** Lock icon for a hard dependency; omit for an informational chip. */
    locked?: boolean;
};

/**
 * Explains why a row is disabled (or what it pairs with) and links to the setting responsible,
 * instead of hiding the row the way the old page did.
 */
export const SettingsDependencyChip = (props: Props) => {
    const page = useSettingsPage();

    // "not_used_while_on" and "not_available_with_on" wrap the link: "Not used while <Service levels> is on".
    const wraps = props.reasonKey === "not_used_while_on" || props.reasonKey === "not_available_with_on";
    const prefixKey = wraps ? `${props.reasonKey}_prefix` : props.reasonKey;
    const suffixKey = wraps ? `${props.reasonKey}_suffix` : null;

    return (
        <span className={"SettingsChip dependency"} data-testid={`dependency-${props.targetTitleKey}`}>
            {props.locked ? <i className={"fad fa-lock"} aria-hidden={true} /> : null}
            <OwLabel title={prefixKey} noBottomMargin={true} />
            <button
                type={"button"}
                className={"SettingsChip-link"}
                onClick={() => {
                    page.jumpToRow(props.targetId);
                }}>
                <OwLabel title={props.targetTitleKey} noBottomMargin={true} />
            </button>
            {suffixKey ? <OwLabel title={suffixKey} noBottomMargin={true} /> : null}
        </span>
    );
};

export default SettingsDependencyChip;
